import { Button, Stack, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { PATH_AUTH } from "../../routes/paths";
import Logo from "../../components/logo";
import useResponsive from "../../hooks/useResponsive";

function Header() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isDesktop = useResponsive("up", "md");

  const dynamicHeader = ["/login", "/reset-password", "/login-verify"].includes(
    pathname
  ) ? (
    <>
      <Stack flexDirection={"row"} alignItems={"center"} gap={1}>
        {isDesktop && <Typography>Don’t have and account?</Typography>}
        <Button variant="contained" onClick={() => navigate(PATH_AUTH.signUp)}>
          Sign Up
        </Button>
      </Stack>
    </>
  ) : (
    <>
      <Stack flexDirection={"row"} alignItems={"center"} gap={1}>
        {isDesktop && <Typography>Already have account?</Typography>}
        <Button variant="contained" onClick={() => navigate(PATH_AUTH.login)}>
          Sign in
        </Button>
      </Stack>{" "}
    </>
  );

  return (
    <Stack
      flexDirection={"row"}
      justifyContent={"space-between"}
      alignItems={"center"}
      py={2}
      px={4}
    >
      <Logo />
      <Stack flexDirection={"row"} gap={1} alignItems={"center"}>
        {dynamicHeader}
        {/* <Iconify icon={"mdi:search"} height={40} width={40} /> */}
      </Stack>
    </Stack>
  );
}

export default Header;
